import { EVIDENCE_MAX_LENGTH, EVIDENCE_MIN_LENGTH } from '../../constants';

// Mirrors the backend's zod rule: trim, then 10–2000 characters.
export const getIsEvidenceValid = (evidence: string): boolean => {
    const trimmed = evidence.trim();

    return trimmed.length >= EVIDENCE_MIN_LENGTH && trimmed.length <= EVIDENCE_MAX_LENGTH;
};
